module.exports = __webpack_public_path__ + "img/101-j-6.prt.628c7dc2.jpg";